import React from 'react';
import numberFormatter from '../../../utils/numberFormatter.js';
import NumberRounding from '../../../utils/numberRounding.js';
import IDSExportButton from '../IDSExportButton.jsx';
import SpotplanIDSExportButton from '../SpotplanIDSExportButton.jsx';
import PanelIDSExportButton from '../PanelIDSExportButton.jsx';
import PanelExportButton from '../PanelExportButton.jsx';
import * as consts from '../../../models/consts.js'
import QueryStringService from '../../../services/queryStringService.js';

const CONST_SPOTPLAN_SPOTLENGTH = 5;

export default class CampaignSummaryPlayLocalParam5 extends React.Component {
    constructor() {
        super();
        let queryStringService = new QueryStringService();
        this.country = queryStringService.getCurrentCountry();
        this.state = {
        };
    }

    validateSovAgainstList(sov) {
        if (this.props.parameters.idsValidSoVValues) {
            if (this.props.parameters.idsValidSoVValues.includes(sov)) {
                return true
            }
        }
        return false
    }

    shouldShow() {
        return Array.from(arguments).includes(this.country);
    }

    render() {
        let target = null;
        let campaignPromise = this.props.campaignPackagePromise
        let notStarted = this.props.campaignInfo.notStarted
        const targetSov = NumberRounding.round(this.props.selectedOrderLines[0].targetSoV * 100.0, 2);
        const targetSoVWithoutRounding = this.props.selectedOrderLines[0].targetSoV;
        const targetScreens = this.props.selectedOrderLines[0].targetScreens;
        const goalMultiplier = this.props.parameters.playSuccessLimit / 100.0;
        let deliveredSov = this.props.campaignInfo.soV;

        let showIDSValues = false
        let vacImportedLabel = 'EA VAC ' + (this.shouldShow(consts.Countries.se,consts.Countries.no) ? '*' : '' );
        let showVAC = false

        let showScreens = false
        let showPlays = false
        let showSoV = false
        let explanatoryText = "*Calculated based on a 5 sec spot length and for an average week.";


        //Buttons
        let showIDSresultExportButton = false;
        let showIDSFaceIdExportButton = false;
        let showIDSSpotPlanExportButton = false;
        let justifyButtonRight = true;

        const campaignHasEnded = !notStarted && moment(this.props.dataFetchedInUTC).format('YYYY-MM-DD') > moment(this.props.campaignInfo.periodEnd).format('YYYY-MM-DD');
        let soVscreens = this.props.campaignInfo.screensThatMatchPromisedSoV
        let deliveredScreens = this.props.campaignInfo.notStarted ? 0 : this.props.campaignInfo.screens;

        switch (campaignPromise) {
            case consts.CampaignPromisePackings.sovp:
                showSoV = true
                deliveredSov = (this.props.selectedData.panels.reduce((acc, val) => { return acc + (val.soV * 100); }, 0) / targetScreens) / 100;
                break;
            case consts.CampaignPromisePackings.sov:
                showIDSresultExportButton = true;
                showIDSFaceIdExportButton = true;
                showIDSSpotPlanExportButton = true;
                justifyButtonRight = false;

                vacImportedLabel = 'VAC ' + (this.shouldShow(consts.Countries.se, consts.Countries.no) ? '*' : '');
                explanatoryText = "*Based on a 5 sec spot length. Only screens delivering 97 % of Promised SoV % during campaign period. Result based on “Face ID list to IDS” and “Spotplan to IDS” (based on Promised SOV) in IDS. Note I: works only for screens in IDS and for Spotplan applicable in IDS."

                showIDSValues = true;
                if (this.props.campaignInfo.idsTarget !== null && this.props.campaignInfo.idsTarget !== "")
                    target = this.props.campaignInfo.idsTargetRaw;
                break;

            case consts.CampaignPromisePackings.fxp:
                showVAC = true
                target = this.props.selectedOrderLines[0].targetVAC;
                break;

            case consts.CampaignPromisePackings.flexai:
                showScreens = true
                if (soVscreens && soVscreens.length == 'undefined') {deliveredScreens =  0}
                else {deliveredScreens =  soVscreens}
                target = this.props.selectedOrderLines[0].targetScreens;
                break;

            case consts.CampaignPromisePackings.sovd:
                showScreens = true;
                target = this.props.selectedOrderLines[0].targetScreens;
                break;

            
            case consts.CampaignPromisePackings.vac:
                showVAC = true
                target = this.props.selectedOrderLines[0].targetVAC;
                break;

            case consts.CampaignPromisePackings.sfi:
                showPlays = true
                target = this.props.selectedOrderLines[0].targetPlays;
                break;
            default:
                target = this.props.selectedOrderLines[0].targetVAC;
                break;
        }

        let plays = this.props.campaignInfo.plays
        let vacContacts = this.props.campaignInfo.vacContacts
        const idsExportFileExists = this.props.campaignInfo.idsExportFileExists;
        const idsExportFileVAC = this.props.campaignInfo.idsVac;

        function handleCampaignStatus(deliveredScreens, panels) {
            if (notStarted) {return 'Not started'}
            if (!campaignHasEnded) { return 'Ongoing' }
            switch (campaignPromise) {
                case consts.CampaignPromisePackings.sfi: {
                    let division = plays / target;
                    if (!Number.isFinite(division))
                        division = 0;

                    let playsDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier && target > 0) {
                        if (playsDeliveredPercentage) { return 'Delivered (' + playsDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + playsDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.vac: {
                    let division = vacContacts / target;
                    if (!Number.isFinite(division))
                        division = 0;
                    let vacDeliveredPercentage = numberFormatter.numberAsPercent(division)
                    if (division.toFixed(2) >= goalMultiplier && target > 0) {
                        if (vacDeliveredPercentage) { return 'Delivered (' + vacDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + vacDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.fxp: {
                    let division = vacContacts / target;
                    if (!Number.isFinite(division))
                        division = 0;
                    let vacDeliveredPercentage = numberFormatter.numberAsPercent(division)
                    if (division.toFixed(2) >= goalMultiplier && target > 0) {
                        if (vacDeliveredPercentage) { return 'Delivered (' + vacDeliveredPercentage + ')' }
                        return 'Delivered'
                    }

                    return 'Not Delivered (' + vacDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.flexai: {
                    let division = deliveredScreens / targetScreens;
                    if (!Number.isFinite(division))
                        division = 0;

                    let screensDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier && targetScreens > 0) {
                        if (screensDeliveredPercentage) { return 'Delivered (' + screensDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + screensDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.sovd: {
                    let division = panels.length / targetScreens;
                    if (!Number.isFinite(division))
                        division = 0;

                    let screensDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier && targetScreens > 0) {
                        if (screensDeliveredPercentage) { return 'Delivered (' + screensDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + screensDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.sovp: {
                    let division = deliveredSov / targetSoVWithoutRounding;
                    if (!Number.isFinite(division))
                        division = 0;

                    let soVDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier) {
                        if (soVDeliveredPercentage) { return 'Delivered (' + soVDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + soVDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.sov: {
                    if (!idsExportFileExists || target == null) { return 'Awaiting data' }

                    let convertedTarget = 0;
                    if (target !== null && target !== "")
                        convertedTarget = +target;

                    let showPercentage = (idsExportFileVAC / (convertedTarget === 0 ? 1 : convertedTarget)).toFixed(2)
                    let importedVacDeliveredPercentage = numberFormatter.numberAsPercent(showPercentage);
                    if (showPercentage >= goalMultiplier && convertedTarget > 0) {
                        if (importedVacDeliveredPercentage) { return 'Delivered (' + importedVacDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + importedVacDeliveredPercentage + ')'
                }
                default:
                    return ''
            }
        }

        return (
            <div>
                <div className={'campaign-summary-promises2 play-background'}>
                    <div style={{'width': '100%', 'float': 'left', 'paddingBottom': '18px'}}>
                        <div className={'.float-sm-right'}>
                            <h3 style={{'float': 'left', 'textAlign':'left' }}>Campaign status</h3>
                        </div>
                        <div className="text-right text-md-left">
                            <h3 style={{'float': 'right', 'textAlign':'right', 'paddingRight': '18px' }}>{handleCampaignStatus(deliveredScreens, this.props.selectedData.panels)}</h3>
                        </div>
                    </div>

                    <div style={{'paddingBottom': '10px'}}>
                        <table style={{'width': '100%'}}>
                            <tbody>
                                <tr>
                                    <th>Campaign promise</th>
                                    <th>Promised</th>
                                    <th>Delivered</th>
                                </tr>

                                {showScreens &&
                                    <tr>
                                        <td className="table-cell-btm-padding">Screen(s){this.shouldShow(consts.Countries.se) && <span>*</span>}</td>
                                        <td className="table-cell-btm-padding">{targetScreens}</td>
                                        <td className="table-cell-btm-padding">{deliveredScreens}</td>
                                    </tr>
                                }
                                {showSoV &&
                                    <tr>
                                        <td className="table-cell-btm-padding">Share of Voice (SOV)</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithOneDecAndProcent(targetSoVWithoutRounding)}</td>
                                        <td className="table-cell-btm-padding pop-tooltip">{numberFormatter.numberWithOneDecAndProcent(deliveredSov)}
                                            <span class="pop-tooltiptext">Accumulated SOV                                                
                                                <hr style={{ 'marginTop': '0', 'marginBottom': '0', 'marginLeft': '10px', 'marginRight': '10px' }}></hr>
                                                Promised screens
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {showIDSValues &&
                                    <tr>
                                        <td className="table-cell-btm-padding">{vacImportedLabel}</td>
                                        <td className="table-cell-btm-padding">{(target !== null && target !== "") ? numberFormatter.numberWithSpaces(+target) : 'Awaiting data'}</td>
                                        <td className="table-cell-btm-padding">{this.props.campaignInfo.idsExportFileExists ? numberFormatter.numberWithSpaces(this.props.campaignInfo.idsVac) : 'Awaiting data'}</td>
                                    </tr>
                                }                                
                                {showVAC &&
                                    <tr>
                                        <td className="table-cell-btm-padding">{vacImportedLabel}</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(target)}</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(vacContacts)}</td>
                                    </tr>
                                }
                                {showPlays &&
                                    <tr>
                                        <td className="table-cell-btm-padding">Plays</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(target)}</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(plays)}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row" style={{ display: 'flex', flexDirection: 'row', justifyContent: justifyButtonRight ? 'right' : 'space-between', paddingRight: justifyButtonRight ? "10px" : "0px"}}>

                    <PanelExportButton
                        panels={this.props.selectedData.panels}
                        campaignType={this.props.selectedCampaignType}
                        campaignName={this.props.campaignName}
                        allowAddressExport={true}
                        exportPanelSOVValue={this.props.parameters.clientSettings.exportPanelSOVValue}
                    />
                    {showIDSFaceIdExportButton &&
                        <PanelIDSExportButton
                            allowExport={campaignHasEnded}
                            useIDSExportFormat={true}
                            considerSoVWhenExportingIDSPanels={true}
                            targetSoV={targetSoVWithoutRounding}
                            panels={this.props.selectedData.panels}
                            campaignType={this.props.selectedCampaignType}
                            campaignName={this.props.campaignName}
                            label={'Face ID list to IDS' + (this.shouldShow(consts.Countries.se, consts.Countries.no) ? '*' : '')}
                            SoVFaultTolerance={goalMultiplier}
                            SoVNoOfDecimals={this.props.parameters.soVNumberOfDecimals}
                            periodStart={this.props.campaignInfo.periodStart}
                            newSOVCalculationFrom={this.props.parameters.clientSettings.newSOVCalculationFrom}
                            style={{ width: '140px' }} />
                    }
                    {showIDSSpotPlanExportButton &&
                        <SpotplanIDSExportButton
                            allowSpotplanExport={campaignHasEnded}
                            spotlength={CONST_SPOTPLAN_SPOTLENGTH}
                            targetSoV={targetSov}
                            campaignName={this.props.campaignName}
                            showLoadingIcon={true}
                            style={{ minWidth: "140px" }} />
                    }
                    {showIDSresultExportButton &&
                        <IDSExportButton
                            allowIDSExport={this.props.campaignInfo.idsExportFileExists}
                            orderlineid={this.props.selectedOrderLines[0].id}
                            campaignName={this.props.campaignName}
                            showLoadingIcon={true} />
                    }


                </div>
                <div className={'col-md-12'}>
                    <div style={{ 'paddingLeft': '0px', 'paddingRight': '20px', 'textAlign': 'left', 'width': '100%', 'fontStyle': 'italic', 'fontSize': 8 }}>
                        <div style={{ 'whiteSpace': 'pre-line' }}></div>
                        <br />
                        {explanatoryText}                        
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}

